import React from 'react';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';

export default function ContactInfo(): React.ReactElement {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 lg:px-12 lg:py-16">
        <div className="mx-auto max-w-6xl">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-semibold leading-tight text-slate-900 sm:text-4xl">
              Contact Information
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
              Reach out to us through any of the following channels
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {/* Email */}
            <div className="rounded-2xl bg-sky-600 p-6 text-white transition-transform hover:scale-105">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
                  <EmailOutlinedIcon fontSize="medium" />
                </div>
                <h3 className="text-lg font-semibold">Email</h3>
              </div>
              <a
                href="mailto:Info@ancientengineering.co.zw"
                className="text-sm text-white/90 hover:text-white transition-colors break-all"
              >
                Info@ancientengineering.co.zw
              </a>
            </div>

            {/* Location */}
            <div className="rounded-2xl bg-sky-600 p-6 text-white transition-transform hover:scale-105">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
                  <LocationOnOutlinedIcon fontSize="medium" />
                </div>
                <h3 className="text-lg font-semibold">Location</h3>
              </div>
              <p className="text-sm text-white/90">161 Gleneagles RD Harare, Zimbabwe</p>
            </div>

            {/* Phone */}
            <div className="rounded-2xl bg-sky-600 p-6 text-white transition-transform hover:scale-105">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
                  <PhoneOutlinedIcon fontSize="medium" />
                </div>
                <h3 className="text-lg font-semibold">Phone</h3>
              </div>
              <div className="space-y-1">
                <a
                  href="tel:+263772960955"
                  className="block text-sm text-white/90 hover:text-white transition-colors"
                >
                  +263 77 296 0955
                </a>
                <a
                  href="tel:+263772813788"
                  className="block text-sm text-white/90 hover:text-white transition-colors"
                >
                  +263 77 281 3788
                </a>
              </div>
            </div>

            {/* Business Hours */}
            <div className="rounded-2xl bg-sky-600 p-6 text-white transition-transform hover:scale-105">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
                  <AccessTimeOutlinedIcon fontSize="medium" />
                </div>
                <h3 className="text-lg font-semibold">Business Hours</h3>
              </div>
              <div className="space-y-1">
                <p className="text-sm text-white/90">Monday - Friday</p>
                <p className="text-sm text-white/90">8:00 AM - 5:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


